// Generated by CoffeeScript 2.7.0
// keep it same with backend
// app/services/response_calculate_service.rb
var CalculationSandbox, DELAY;

DELAY = 2000;

export default CalculationSandbox = class CalculationSandbox {
  constructor() {
    this.workerTimeoutID = void 0;
    this.worker = void 0;
    this.cb = void 0;
  }

  calculate(raw_response, cb) {
    this.cb = cb;
    this.__generateCalculationWorker();
    this.worker.postMessage(raw_response);
    return this.workerTimeoutID = setTimeout(this.__terminateWorker.bind(this, 'timeout'), DELAY);
  }

  __generateCalculationWorker() {
    this.__terminateWorker('new');
    this.worker = new Worker(_cargo.calculation_sandbox_js);
    return this.__initEventListener();
  }

  __terminateWorker(reason) {
    if (this.workerTimeoutID !== void 0) {
      clearTimeout(this.workerTimeoutID);
      this.workerTimeoutID = void 0;
    }
    if (this.worker !== void 0) {
      this.worker.terminate();
      this.worker = void 0;
    }
    if ((reason === 'timeout') && this.cb) {
      return this.__comsumeCallback('timeout');
    }
  }

  __initEventListener() {
    this.worker.onmessage = (e) => {
      this.__terminateWorker('normal');
      return this.__comsumeCallback(e.data);
    };
    return this.worker.onerror = function(error) {
      console.log(error);
      return console.log('不支持计算字段');
    };
  }

  __comsumeCallback(data) {
    var callback;
    callback = this.cb;
    this.cb = void 0;
    return callback(data);
  }

};
